import { useEffect } from 'react';

import WebApp from '@twa-dev/sdk';

import { isTMA } from '@/shared/helpers/is-tma';

export const useEnableClosingConfirmation = () => {
  useEffect(() => {
    if (!isTMA()) return;

    WebApp.enableClosingConfirmation();
  }, []);
};
